const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const formatBRL = (value: number): string => brl.format(value).replace(/\u00a0/g, " ");

export const emissionFeeLabel = (value: number): string => `Taxa única de emissão: ${formatBRL(value)}`;

export const emissionFeeText = (value: number, note: string): string => `${emissionFeeLabel(value)} (${note})`;

export const formatISODateBR = (iso: string): string => iso.split("-").reverse().join("/");

export function formatTimestampBR(d: Date): string {
  const date = d.toLocaleDateString("pt-BR");
  const time = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  return `${date} às ${time}`;
}
